/**
 * `/f/:abbr` and `/f/:abbr/:school` — the short link inside the funding texts.
 * A 160-character SMS cannot afford the full re-send URL, so the templates
 * link `sportsacademygames.com/f/tx` (or `/f/tx/homeschool` when a school
 * filter was used) and this route redirects to /funding-check with the public
 * params, keeping any utm_* / fbclid on the incoming link. An unknown state
 * still lands on the quiz rather than a 404.
 */
import * as React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { FUNDING_SCHOOL_TYPE_OPTIONS, fundingStateByAbbr } from "@stratacademy/core";
import { URL_PARAM } from "./funding-check-state.js";

export function FundingShortLinkRoute(): React.ReactElement {
  const { abbr = "", school = "" } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const state = fundingStateByAbbr(abbr);
  if (state) params.set(URL_PARAM.state, state.name);
  const type = school.trim().toLowerCase();
  if (state && (FUNDING_SCHOOL_TYPE_OPTIONS as readonly string[]).includes(type)) {
    params.set(URL_PARAM.school, type);
  }
  const qs = params.toString();
  return <Navigate replace to={`/funding-check${qs ? `?${qs}` : ""}`} />;
}
